import type { TableColumnSize } from '@core-engine/schema/types.js'

const TABLE_COLUMN_SIZE_PRESETS: Record<TableColumnSize, number> = {
  sm: 120,
  default: 220,
  lg: 320,
  xl: 420
}

export function getTableColumnSize(size: TableColumnSize | undefined): number {
  return TABLE_COLUMN_SIZE_PRESETS[size ?? 'default'] ?? TABLE_COLUMN_SIZE_PRESETS.default
}

export function buildColumnSize(size: TableColumnSize | undefined): string {
  return `size: ${getTableColumnSize(size)},\n    `
}
